import moment, {Moment} from 'moment';

require('moment/locale/pt-br.js');
moment.locale('pt-br');

export interface IDateService {
  parseToMoment(date: any, format?: string): Moment;

  parseDateToString(date: any, format: string): string;

  parseStringToDate(date: any, format: string): Date;
}

export class DateService implements IDateService {
  public parseToMoment(date: any = new Date(), format?: string): Moment {
    return format ? moment(date, format) : moment(date);
  }

  public parseDateToString(date: any = new Date(), format = 'L'): string {
    return moment(date).format(format);
  }

  public parseStringToDate(date: any = new Date(), format = 'L'): Date {
    return moment(date, format).toDate();
  }
}

export const dateService = new DateService();
export const parseToMoment = dateService.parseToMoment;
export const parseDateToString = dateService.parseDateToString;
export const parseStringToDate = dateService.parseStringToDate;
